import { Heading, Stepper } from "@/components"
import usePropertyBulkUpload from "./useBulkUpload";
import { cn } from "@/lib/utils";
import { steps, stepsForDuplicate } from "./consts";
import { Step1, Step2, Step3, Step4 } from "./Steps";

const PropertyBulkUpload = () => {
  const {
    breadcrumbData,
    isMobile,
    currentStep,
    onBackClick,
    onNextStepClick,
    onPreviousStepClick,
    hasDuplicateRows
  } = usePropertyBulkUpload();

  return (
    <div className="p-4 md:p-6"> 
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-1">
          <Heading
            title="Bulk Upload Users"
            breadcrumbData={breadcrumbData}
          />
          <div className={cn(isMobile ? "pt-4" : "pt-6 px-6")}>
            <Stepper
              steps={hasDuplicateRows ? stepsForDuplicate : steps}
              currentStep={currentStep}
              // onStepperClick={onStepperClick}
            />
        </div>
      </div>

      {currentStep == 1 ?
        <Step1 onNextStepClick={onNextStepClick} onBackClick={onBackClick} /> : 
        currentStep == 2 ?
          <Step2
            onNextStepClick={onNextStepClick}
            onPreviousStepClick={onPreviousStepClick}
            onBackClick={onBackClick}
          /> :
          currentStep == 3 ? 
            hasDuplicateRows ? 
              <Step3
                onNextStepClick={onNextStepClick}
                onPreviousStepClick={onPreviousStepClick}
                onBackClick={onBackClick} 
              />
            : <Step4 onBackClick={onBackClick} /> 
          : currentStep == 4 ? 
            <Step4 onBackClick={onBackClick} /> 
            : <></>
      }
      
    </div>
  )
}

export default PropertyBulkUpload;